import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { MessengerService } from './messenger.service';
import { Program } from 'src/app/program/model/program';

/**
 * Service class for Programs.
 */
@Injectable({
  providedIn: 'root'
})
export class ProgramService implements OnDestroy
{
  /**
   * List of Group By selection
   */
  public listGroupBy: Array<{ text: string; value: string }> = [
    { text: 'Program Category', value: 'category' },
    { text: 'Performance', value: 'performance' },
    { text: 'Program', value: 'program' },
    { text: 'Status', value: 'status' }
  ];

  private messagingLanguageChangedSubscription: Subscription;

  /**
   * Constructor
   *
   * @param http Auto injected Angular HttpClient
   */
  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private messengerService: MessengerService
  )
  {
    this.loadLocalizations();
    this.messagingLanguageChangedSubscription = this.messengerService.receiveMessage().subscribe({
      next: (message) =>
      {
        if (message && message.type && message.type === 'languageChanged')
        {
          this.loadLocalizations();
        }
      }
    });
  }

  public ngOnDestroy(): void
  {
    if (this.messagingLanguageChangedSubscription !== undefined) { this.messagingLanguageChangedSubscription.unsubscribe(); }
  }

  /**
   * Get all Programs templates from REST service.
   */
  public getProgramsTemplates(): Observable<any[]>
  {
    return this.http.get<any[]>('/programs/templates');
  }

  /**
   * Get Program by id.
   *
   * @param id Program  id
   */
  public getProgram(id: number): Observable<Program>
  {
    return this.http.get<Program>(`/programs/${id}`);
  }

  /**
   * Persist a Program in the database.
   *
   * @param data Data to save
   * @param isNew Is this a new Program?
   */
  public saveProgram(data: Program, isNew: boolean, programId?: number): Observable<any>
  {
    if (isNew)
    {
      return this.http.post('/programs', data);
    }
    else
    {
      return this.http.put(`/programs/${programId}`, data);
    }
  }

  /**
   * Delete a Program.
   *
   * @param id Program id
   */
  public deleteProgram(id: number): Observable<any>
  {
    return this.http.delete<any>(`/programs/${id}`);
  }

  /**
   * Get Program Metrics by id.
   *
   * @param id Program id
   */
  public getProgramMetrics(id: number): Observable<any>
  {
    return this.http.get<any>(`/programs/${id}/metrics`);
  }

  /**
   * Load localizations
   */
  private loadLocalizations(): void
  {
    // Set the filter options localization
    this.translate.get(['PROGRAM-GROUPING-OPTIONS']).subscribe({
      next: (res) =>
      {
        let index = 0;
        for (const key in res)
        {
          if ({}.hasOwnProperty.call(res, key))
          {
            const splitted = res[key].split(',');
            for (let i = 0; i < splitted.length; i++)
            {
              switch (index)
              {
                case 0:
                  this.listGroupBy[i].text = splitted[i];
                  break;
              }
            }
            index++;
          }
        }
      }
    });
  }
}
